export const UserRoles = {
  AccountManager: 4,
  RoimaticUser: 15,
  BrandManager: 16,
  ClientAccess: 27,
  BizgainAdmin: 44,
  BizgainClientAccess: 45
}